import React from 'react';
import {
  ProgressBar,
  Typography
} from '@one-thd/sui-atomic-components';
import { PropTypes } from "prop-types";

export const IntentResolutionProgress = ({
  progress
}) => {
  const {
    itemCount,
    resolutionProgress
  } = progress;
    return (
      <div className="sui-w-full sui-flex sui-flex-col sui-gap-1">
        <Typography variant="body-lg" weight="bold">Hang Tight!</Typography>
        <Typography variant="body-base">
          We're finding the right products for you.
        </Typography>
        <div className="sui-pt-8">
          <ProgressBar
            status={resolutionProgress === 100 ? 'success' : undefined}
            value={resolutionProgress}
            startLabel={`${itemCount} items`}
            endLabel={`${resolutionProgress}%`}
          />
        </div>
      </div>
    );
};

IntentResolutionProgress.propTypes = {
  progress: PropTypes.shape({
    itemCount: PropTypes.number,
    resolutionProgress: PropTypes.number
  }).isRequired
};
